<template>
    <div v-if="isStudents" id="no-payment-overlay" :style="{ 'z-index': zIndex }">
        <div id="box-text" class="system-border flex flex-col items-center justify-center">
            <p class="text-center shadow-text-none text-lg font-bold">
                {{ $t('overlay_ask_for_premium_access') }}
            </p>
            <button
                @click="$emit('close')"
                class="system-button-color system-button-text-color btn btn-small font-opensans text-md mt-3 uppercase"
            >
                {{ $t('overlay_close_button') }}
            </button>
        </div>
    </div>
</template>

<script>
import { currentUser } from '@/lib/user'

export default {
    props: {
        zIndex: {
            type: Number,
            default: 99
        }
    },

    computed: {
        isStudents() {
            return currentUser().role === 'student_plus' || currentUser().role === 'student'
        }
    }
}
</script>

<style scoped lang="scss">
#no-payment-overlay {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    z-index: 99;

    #box-text {
        position: absolute;
        top: 35%;
        padding: 1.75rem;
        margin: 1rem;
        border-radius: 0.5rem;
        background-color: #fff;
    }
}
</style>
